import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  const forWho = ['Sientes que tu ropa te ensancha aunque estés arreglada', 'Quieres verte pulida sin gastar más dinero', 'Eres mamá o profesional con poco tiempo en las mañanas', 'Tu cuerpo cambió y no sabes cómo vestirlo ahora', 'Quieres recuperar tu confianza frente al espejo'];
  const notForWho = ['Buscas tendencias de alta costura o pasarela', 'No estás dispuesta a probar combinaciones nuevas', 'Ya eres estilista profesional certificada', 'Buscas un plan de dieta o ejercicio'];
  return <section className="py-12 sm:py-16 px-4 bg-brand-bg" data-id="element-133">
      <div className="max-w-content mx-auto" data-id="element-134">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-135">
          {/* For Who */}
          <FadeIn data-id="element-136">
            <div className="bg-brand-green-bg rounded-2xl p-6 sm:p-8 h-full border border-green-200" data-id="element-137">
              <h3 className="text-xl font-bold text-green-900 mb-6 flex items-center gap-2" data-id="element-138">
                <Check className="w-6 h-6 text-green-600" strokeWidth={3} data-id="element-139" />
                Este sistema es para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-140">
                {forWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-141">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-142" />
                    <span className="text-green-900/80 font-medium leading-relaxed" data-id="element-143">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not For Who */}
          <FadeIn delay={0.2} data-id="element-144">
            <div className="bg-brand-red-bg rounded-2xl p-6 sm:p-8 h-full border border-red-200" data-id="element-145">
              <h3 className="text-xl font-bold text-red-900 mb-6 flex items-center gap-2" data-id="element-146">
                <X className="w-6 h-6 text-red-600" strokeWidth={3} data-id="element-147" />
                No es para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-148">
                {notForWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-149">
                    <X className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-150" />
                    <span className="text-red-900/80 font-medium leading-relaxed" data-id="element-151">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}